import { components } from 'react-select';
import { ENV_CONFIG } from 'config/environment';
import { Image } from 'components/Image';
import { useAppSelector } from 'helpers/hooks';
import { getRecipientsData } from 'selectors/recipients';

export const CustomOption = props => {
  const recipients = useAppSelector(getRecipientsData);
  const option = recipients.find(rec => rec.recipient_id === props.data.value);
  return (
    <components.Option {...props}>
      <div className="row space-between">
        <div className="row">
          <Image
            src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/recipients/rec_${option?.misc_ids?.photo_id}.jpg`}
            alt={props.data.label}
            className="search-image"
            fallbackImgType="candidate_square"
          />
          <div className="grid">
            <span className="body-small-text">{props.data.label}</span>
            <span className="body-small-text">{option?.race?.election?.display_info}</span>
          </div>
        </div>
        <span className="search-impact">{option?.impact_score}</span>
      </div>
    </components.Option>
  );
};
